import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { handleActions } from 'redux-actions';
import pick from 'lodash/pick';
import { reduxKey } from './constants';
import { logPageView } from './actions';
const actionHandlers = handleActions({
    [logPageView.toString()]: (state, { payload  })=>{
        return _object_spread_props(_object_spread({}, state), {
            pageview: pick(payload, 'view', 'component', 'typeid', 'itemid')
        });
    }
}, {
    pageview: {}
});
export default {
    [reduxKey]: actionHandlers
};
